// Angular
import { forwardRef, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
// Material
import { MatButtonModule, MatCheckboxModule, MatFormFieldModule, MatInputModule, MatSelectModule } from '@angular/material';
// Translate
import { TranslateModule } from '@ngx-translate/core'
import { InterceptService } from '../../../core/_base/crud/utils/intercept.service';
//Toaster
import { ToastrModule } from 'ngx-toastr';
// Module components
import { AuthComponent } from './auth.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { AuthNoticeComponent } from './auth-notice/auth-notice.component';
import { SetPasswordComponent } from './set-password/set-password.component';
// Auth
import { AuthGuard,  AuthService } from '../../../core/auth';
import { LogoutComponent } from './logout/logout.component';
import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';
import { AttorneyLoginComponent } from './attorneylogin/attorneylogin.component';
import { MustMatchDirectiveAuth } from './register/must-match.directive';
import { AttorneyForgotPasswordComponent } from './attorney-forgot-password/attorney-forgot-password.component';
const routes: Routes = [
	{
		path: '',
		component: AuthComponent,
		children: [
			{
				path: '',
				redirectTo: 'login',
				pathMatch: 'full'
			},
			{
				path: 'login',
				component: LoginComponent,
				data: {returnUrl: window.location.pathname}
			},
			{
				path: 'attorney/login',
				component: AttorneyLoginComponent,
				data: {returnUrl: window.location.pathname}
			},
			{
				path: 'logout',
				component: LogoutComponent,
				data: {returnUrl: window.location.pathname}
			},
			{
				path: 'attorney/register',
				component: RegisterComponent
			},
			{
				path: 'forgot-password',
				component: ForgotPasswordComponent,
			},
			{
				path: 'attorney/forgot-password',
				component: AttorneyForgotPasswordComponent,
			},
			{
				path: 'set-password',
				component: SetPasswordComponent,
			}
		]
	}
];


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatSelectModule,
		MatButtonModule,
		RouterModule.forChild(routes),
		MatInputModule,
		MatFormFieldModule,
		MatCheckboxModule,
		TranslateModule.forChild(),
		ToastrModule.forRoot({
			timeOut: 3000,
			positionClass: 'toast-bottom-right',
			preventDuplicates: true,
		  }),
		MatPasswordStrengthModule.forRoot()
	],
	providers: [
		InterceptService,
		{
			provide: HTTP_INTERCEPTORS,			
			useClass: forwardRef(() => InterceptService),
			multi: true
		},
	],
	exports: [AuthComponent],
	declarations: [
		AuthComponent,
		LoginComponent,
		RegisterComponent,
		ForgotPasswordComponent,
		AttorneyForgotPasswordComponent,
		AuthNoticeComponent,
		SetPasswordComponent,
		LogoutComponent,		
		AttorneyLoginComponent,
		MustMatchDirectiveAuth
	]
})

export class AuthModule {
	static forRoot(): ModuleWithProviders {
		return {
			ngModule: AuthModule,
			providers: [
				AuthService,
				AuthGuard
			]
		};
	}
}
